import { controls, currencyToNumber, grouped } from "../../controls";

const rpcf6 = {
  label: "Consolidated Report",
  starting: true,
  url: "rp101m",
  pageLabel: "Consolidated Report",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.displayText({ tab: "general", label: "Portal", star: false }),
    ...controls.autoComplete({ tab: "general", name: "portal_scheme_code", width: "col-sm-2", controlType: "PortalScheme" }),
    ...controls.displayText({ tab: "general", label: "" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Consolidated Report",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A3", pageOrientation: "landscape" },
    pivot: true,

    extraRows: {
      location: "bottom",
      fields: ["total_amount", "total_count", "matched_amount", "matched_count", "mismatched_amount", "mismatched_count", "attalathi_amount", "attalathi_count", "attehsildar_amount", "attehsildar_count", "atbank_amount", "atbank_count", "auto_amount", "auto_count", "corrections_amount", "corrections_count", "paid_amount", "paid_count"],
      grandtotal: { type: "fixed", displayIn: "village_name", val: "Grand Total", count: true },
    },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Village",
        accessor: "village_name",
        rwidth: "*",
      },
      {
        Header: "Total",
        columns: [
          {
            Header: "Amount",
            accessor: "total_amount",
            type: "currency"
          },
          {
            Header: "Count",
            accessor: "total_count",
            align: "right"
          },
        ]
      },
      {
        Header: "Matched",
        columns: [
          {
            Header: "Amount",
            accessor: "matched_amount",
            type: "currency"
          },
          {
            Header: "Count",
            accessor: "matched_count",
            align: "right"
          },
        ]
      },
      {
        Header: "Not Matched",
        columns: [
          {
            Header: "Amount",
            accessor: "mismatched_amount",
            type: "currency"
          },
          {
            Header: "Count",
            accessor: "mismatched_count",
            align: "right"
          },
        ]
      },
      {
        Header: "At Talathi",
        columns: [
          {
            Header: "Amount",
            accessor: "attalathi_amount",
            type: "currency"
          },
          {
            Header: "Count",
            accessor: "attalathi_count",
            align: "right"
          },
        ]
      },
      {
        Header: "At Tehsildar",
        columns: [
          {
            Header: "Amount",
            accessor: "attehsildar_amount",
            type: "currency"
          },
          {
            Header: "Count",
            accessor: "attehsildar_count",
            align: "right"
          },
        ]
      },
      {
        Header: "In Process",
        columns: [
          {
            Header: "Amount",
            accessor: "atbank_amount",
            type: "currency"
          },
          {
            Header: "Count",
            accessor: "atbank_count",
            align: "right"
          },
        ]
      },

      {
        Header: "Paid",
        columns: [
          {
            Header: "Amount",
            accessor: "paid_amount",
            type: "currency"
          },
          {
            Header: "Count",
            accessor: "paid_count",
            align: "right"
          },
        ]
      },

      {
        Header: "Auto Matched",
        columns: [
          {
            Header: "Amount",
            accessor: "auto_amount",
            type: "currency"
          },
          {
            Header: "Count",
            accessor: "auto_count",
            align: "right"
          },
        ]
      },
      {
        Header: "Corrections",
        columns: [
          {
            Header: "Amount",
            accessor: "corrections_amount",
            type: "currency"
          },
          {
            Header: "Count",
            accessor: "corrections_count",
            align: "right"
          },
        ]
      }

    ]
  }
};

export default rpcf6;